<mat-label class="subHeading">Total Business <mat-checkbox *ngIf="showInsurerSpecific" [formControl]="isInsurerSpecific">Insurer Specific</mat-checkbox></mat-label>

<div formGroupName="total_business" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="8" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="8" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>